<div *ngIf="projects!== undefined" class="row front">
    <div class="col-md-12">
        <p>Projects</p>
        <p>
            <lfx-logo-list [items]="$any(projects)" [limit]="2"></lfx-logo-list>
        </p>
    </div>
</div>

<div class="row front">
    <div class="col-md-6" (mouseover)="onMouseOver('contributors')" (mouseout)="onMouseLeave()">
        <div>Contributors</div>
        <div class="bold">{{contributors || 'N/A'}}</div>
    </div>
    <div class="col-md-6" (mouseover)="onMouseOver('contributions')" (mouseout)="onMouseLeave()">
        <div>Contributions</div>
        <div class="bold">{{contributions || 'N/A'}}</div>
    </div>
</div>
